<template>
<div class="container">
    <Header/>
    <Main/>
    <Footer/>
    <PrivacySettings/>
</div>
</template>

<script>
import Main from '@/components/layout/Main'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import PrivacySettings from '@/components/PrivacySettings'

export default {
    name: 'I18nView',
    components: {
        Main,
        Header,
        Footer,
        PrivacySettings
    }
}
</script>
